/**
 * BPIO Dashboard Application
 *
 * Main entry point for the Binder Presale Intelligent Orchestrator frontend.
 * Displays real-time order processing and AI verification status.
 */

import React from 'react';
import OrderDashboard from './components/OrderDashboard';
import './App.css';

function App() {
  return (
    <div className="app">
      <OrderDashboard />
    </div>
  );
}

export default App;
